exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":root{--font-size:14px;--header-height:60px;--logo-height:60px;--left-side-width:250px;--breadcrumb-height:20px;--card-border-radius:5px;--card-spacing:16px;--tag-border-radius:5px;--tag-font-size:12px;--uploader-size:178px;--uploader-border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/shopee-theme/dist/shopee/var.css
// module id = 211
// module chunks = 0